// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plant-page{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat bottom right / auto 40vh, rgb(232, 231, 227);
  width: 100%;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  font-family: 'Monaco', monospace;
  position: absolute;
  margin: 0;
  padding: 0;
  overflow: auto;
  z-index: 0;
  }

  .plant-ul{
    margin-right: 10%;
  }

.plant-video {
  width: 100%;
}

.plant-canvas {
  display: none;
}

.result {
  margin-top: 22px;
  padding: 12px;
  background: #f3f3f3;
  border-radius: 10px;
  color: #333;
  font-size: 1rem;
}

.result h2 {
  margin-top: 0;
  font-size: 1.2rem;
  color: #222;
}

.result ul {
  list-style-type: none;
  padding-left: 0;
}

.plant-result-button {
  display: block;
  margin-bottom: 10px;
  width: 100%;
  text-align: left;
}

.plant-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(28, 37, 54, 0.65);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: popupIn .2s;
  backdrop-filter: blur(2px);
}

.plant-modal-content {
  background: #fafdff;
  border-radius: 2rem;
  max-width: 420px;
  width: 92vw;
  box-shadow: 0 12px 40px 0 rgba(0,0,0,0.17);
  padding: 2.2em 1.6em 2.2em 1.6em;
  position: relative;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: popupIn .24s cubic-bezier(0.17,0.67,0.83,0.67);
}

.plant-modal-close {
  position: absolute;
  top: 1.1rem;
  right: 1.2rem;
  background: none;
  border: none;
  font-size: 2.2rem;
  color: #728197;
  cursor: pointer;
  transition: color 0.16s;
  z-index: 2;
  line-height: 1;
}
.plant-modal-close:hover,
.plant-modal-close:focus {
  color: #dc4a4a;
  background: #f7eaea;
  border-radius: 1.8rem;
}

.plant-modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: .7rem;
}

.plant-avatar-container {
  width: 102px;
  height: 102px;
  margin-bottom: 0.5rem;
  border-radius: 50%;
  box-shadow: 0 2px 8px 0 rgba(36,51,69,0.11);
  background: #eef4fa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.plant-modal-avatar {
  width: 92px;
  height: 92px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #deedf3;
  background: #fff;
  display: block;
}

.plant-modal-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #253045;
  margin: 0;
  margin-bottom: 0.2rem;
}

.plant-modal-subtitle {
  font-size: 1.1rem;
  font-weight: 500;
  color: #64b384;
  margin: 0 0 1rem 0;
}

.plant-modal-info-list {
  width: 100%;
  margin-top: .5rem;
  margin-bottom: 0.3rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  font-size: 1rem;
}

.plant-modal-label {
  font-weight: 600;
  color: #475477;
  margin-right: 0.4em;
}

.plant-modal-value {
  color: #263140;
  font-weight: 400;
  margin-left: 0.2em;
}

.plant-modal-error {
  background: #fef3f2;
  color: #ca1b1b;
  font-weight: 500;
  padding: 0.5em 0.8em;
  border-radius: 8px;
  margin-bottom: 0.7rem;
}

.plant-modal-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

@media (max-width: 600px) {
  .plant-modal-content {
    max-width: 99vw;
    padding: 1.1em 0.4em 1.2em 0.4em;
  }
  .plant-modal-header {
    margin-bottom: 0.3rem;
  }
}
@keyframes popupIn {
  from { transform: scale(0.93); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.space-header.sm-space-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.custom-plant-row {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.custom-plant-img {
  width: 32px;
  height: 32px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 8px;
  border: 2px solid #fff;
}

.custom-plant-name {
  color: #fff;
  font-weight: 600;
}

.custom-plant-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Plants.css"],"names":[],"mappings":"AAAA;EACE,0GAAmG;EACnG,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,UAAU;EACV;;EAEA;IACE,iBAAiB;EACnB;;AAEF;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,UAAU;EACV,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,gCAAgC;EAClC;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".plant-page{\n  background: url('../assets/background.webp') no-repeat bottom right / auto 40vh, rgb(232, 231, 227);\n  width: 100%;\n  min-height: 100vh;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Monaco', monospace;\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  overflow: auto;\n  z-index: 0;\n  }\n\n  .plant-ul{\n    margin-right: 10%;\n  }\n\n.plant-video {\n  width: 100%;\n}\n\n.plant-canvas {\n  display: none;\n}\n\n.result {\n  margin-top: 22px;\n  padding: 12px;\n  background: #f3f3f3;\n  border-radius: 10px;\n  color: #333;\n  font-size: 1rem;\n}\n\n.result h2 {\n  margin-top: 0;\n  font-size: 1.2rem;\n  color: #222;\n}\n\n.result ul {\n  list-style-type: none;\n  padding-left: 0;\n}\n\n.plant-result-button {\n  display: block;\n  margin-bottom: 10px;\n  width: 100%;\n  text-align: left;\n}\n\n.plant-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(28, 37, 54, 0.65);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: popupIn .2s;\n  backdrop-filter: blur(2px);\n}\n\n.plant-modal-content {\n  background: #fafdff;\n  border-radius: 2rem;\n  max-width: 420px;\n  width: 92vw;\n  box-shadow: 0 12px 40px 0 rgba(0,0,0,0.17);\n  padding: 2.2em 1.6em 2.2em 1.6em;\n  position: relative;\n  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  animation: popupIn .24s cubic-bezier(0.17,0.67,0.83,0.67);\n}\n\n.plant-modal-close {\n  position: absolute;\n  top: 1.1rem;\n  right: 1.2rem;\n  background: none;\n  border: none;\n  font-size: 2.2rem;\n  color: #728197;\n  cursor: pointer;\n  transition: color 0.16s;\n  z-index: 2;\n  line-height: 1;\n}\n.plant-modal-close:hover,\n.plant-modal-close:focus {\n  color: #dc4a4a;\n  background: #f7eaea;\n  border-radius: 1.8rem;\n}\n\n.plant-modal-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: .7rem;\n}\n\n.plant-avatar-container {\n  width: 102px;\n  height: 102px;\n  margin-bottom: 0.5rem;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px 0 rgba(36,51,69,0.11);\n  background: #eef4fa;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.plant-modal-avatar {\n  width: 92px;\n  height: 92px;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 3px solid #deedf3;\n  background: #fff;\n  display: block;\n}\n\n.plant-modal-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #253045;\n  margin: 0;\n  margin-bottom: 0.2rem;\n}\n\n.plant-modal-subtitle {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #64b384;\n  margin: 0 0 1rem 0;\n}\n\n.plant-modal-info-list {\n  width: 100%;\n  margin-top: .5rem;\n  margin-bottom: 0.3rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  font-size: 1rem;\n}\n\n.plant-modal-label {\n  font-weight: 600;\n  color: #475477;\n  margin-right: 0.4em;\n}\n\n.plant-modal-value {\n  color: #263140;\n  font-weight: 400;\n  margin-left: 0.2em;\n}\n\n.plant-modal-error {\n  background: #fef3f2;\n  color: #ca1b1b;\n  font-weight: 500;\n  padding: 0.5em 0.8em;\n  border-radius: 8px;\n  margin-bottom: 0.7rem;\n}\n\n.plant-modal-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n}\n\n@media (max-width: 600px) {\n  .plant-modal-content {\n    max-width: 99vw;\n    padding: 1.1em 0.4em 1.2em 0.4em;\n  }\n  .plant-modal-header {\n    margin-bottom: 0.3rem;\n  }\n}\n@keyframes popupIn {\n  from { transform: scale(0.93); opacity: 0; }\n  to   { transform: scale(1); opacity: 1; }\n}\n\n.space-header.sm-space-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.custom-plant-row {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.custom-plant-img {\n  width: 32px;\n  height: 32px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin-right: 8px;\n  border: 2px solid #fff;\n}\n\n.custom-plant-name {\n  color: #fff;\n  font-weight: 600;\n}\n\n.custom-plant-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
